<template>
  <header :class="navbarTypeClass()">
    <div
        :class="`app-header md:px-6 px-[15px] dark:bg-slate-800 shadow-base dark:shadow-base3 bg-white ${borderSwicthClass()} ${
        themeSettingsStore.navbarColor
      }
      ${
        themeSettingsStore.menuLayout === 'horizontal' && window.width > 1280
          ? 'py-1'
          : 'py-2'
      }
      `"
    >
      <div class="flex justify-between items-center h-full">
        <div
            v-if="themeSettingsStore.menuLayout === 'vertical'"
            class="flex items-center md:space-x-4 space-x-2 rtl:space-x-reverse"
        >
          <button
              class="ltr:mr-5 rtl:ml-5 text-xl text-slate-900 dark:text-white"
              v-if="themeSettingsStore.sidebarCollasp && window.width > 1280"
              @click="themeSettingsStore.sidebarCollasp = false"
          >
            <svg v-if="!themeSettingsStore.direction" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
            <Icon
                icon="akar-icons:arrow-left"
                v-if="themeSettingsStore.direction"
            />
          </button>
          <MobileLogo v-if="window.width < 1280"/>
          <handle-mobile-menu
              v-if="window.width < 1280 && window.width > 768"
          />
<!--          <SearchModal v-if="$route.meta.searchInput"/>-->
        </div>
        <div
            v-if="themeSettingsStore.menuLayout === 'horizontal'"
            class="flex items-center space-x-4 rtl:space-x-reverse"
        >
          <Logo v-if="window.width > 1280"/>
          <MobileLogo v-else/>
          <handle-mobile-menu v-if="window.width < 1280"/>
        </div>
        <Mainnav
            v-if="
            themeSettingsStore.menuLayout === 'horizontal' && window.width > 1280
          "
        />
        <div
            class="nav-tools flex items-center lg:space-x-5 space-x-3 rtl:space-x-reverse"
        >
          <span v-if="window.width < 768" @click="logout();"
                class="lg:h-[32px] lg:w-[32px] lg:bg-slate-50 lg:dark:bg-slate-900 dark:text-white text-slate-900 cursor-pointer rounded-full text-[20px] flex flex-col items-center justify-center">
            <Icon icon="heroicons-outline:logout"></Icon>
          </span>
          <LanguageVue/>
          <!--          <SwitchDark/>-->
          <!--          <MonochromeMode/>-->
          <!--          <Message v-if="window.width > 768"/>-->
          <Notification v-if="window.width > 768"/>
          <Profile v-if="window.width > 768"/>
          <handle-mobile-menu v-if="window.width < 768"/>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import Profile from "@/components/Header/Navtools/Profile.vue";
import Notification from "@/components/Header/Navtools/Notification.vue";
import Message from "@/components/Header/Navtools/Message.vue";
import SwitchDark from "@/components/Header/Navtools/SwitchDark.vue";
import MonochromeMode from "@/components/Header/Navtools/MonochromeMode.vue";
import Mainnav from "@/components/Header/horizental-nav.vue";
import Icon from "../Icon/index.vue";
/*import SearchModal from "@/components/Header/Navtools/SearchModal.vue";*/
import LanguageVue from "@/components/Header/Navtools/Language.vue";
import Logo from "@/components/Header/Navtools/Logo.vue";
import MobileLogo from "@/components/Header/Navtools/MobileLogo.vue";
import window from "@/mixins/window";
import HandleMobileMenu from "@/components/Header/Navtools/HandleMobileMenu.vue";
import {useThemeSettingsStore} from "@/stores/themeSettings";
import {useLogout} from "@/mixins/logout.js";

export default {
  mixins: [window],
  components: {
    Profile,
    Notification,
    Message,
    SwitchDark,
    MonochromeMode,
    Mainnav,
    Icon,
    LanguageVue,
    Logo,
    MobileLogo,
    HandleMobileMenu,
  },

  methods: {},
  setup() {
    const themeSettingsStore = useThemeSettingsStore()
    const {logout} = useLogout()
    function navbarTypeClass() {
      switch (themeSettingsStore.navbarType) {
        case "floating":
          return "floating";
        case "sticky":
          return "sticky top-0 z-[999]";
        case "static":
          return "static";
        case "hidden":
          return "hidden";
        default:
          return "sticky top-0";
      }
    }

    function borderSwicthClass() {
      if (
          themeSettingsStore.skin === "bordered" &&
          themeSettingsStore.navbarType !== "floating"
      ) {
        return "border-b border-gray-5002 dark:border-slate-700";
      } else if (
          themeSettingsStore.skin === "bordered" &&
          themeSettingsStore.navbarType === "floating"
      ) {
        return "border border-gray-5002 dark:border-slate-700";
      } else {
        return "dark:border-slate-700 dark:border-opacity-60";
      }
    }

    return {
      themeSettingsStore,
      navbarTypeClass,
      borderSwicthClass,
      logout
    }
  }
};
</script>
<style lang="scss" scoped>
.floating .app-header {
  @apply md:mx-6 md:my-8 mx-[15px] my-[15px] rounded-md;
}
</style>
